import React from 'react';
import { Link } from 'react-router-dom';
import CheckboxRenderer from 'components/common/ag-grid/CheckboxRenderer';
import TransactionDateFormatRenderer from '../../../transaction/component/TransactionDateFormatRenderer';
import { formatNumber } from 'helpers/utils';

export const columnDefs = [
  { headerName: 'ID#', field: 'id', minWidth: 90 },
  {
    headerName: 'Booking ID#',
    field: 'booking.number',
    minWidth: 130,
    pinned: 'left',
    cellRenderer: (params) => <Link to={`/booking/car/${params.data?.booking_id}`}>{params.value}</Link>,
  },
  { headerName: 'From date', field: 'booking.from_date', minWidth: 180, cellRenderer: TransactionDateFormatRenderer },
  { headerName: 'To date', field: 'booking.to_date', minWidth: 180, cellRenderer: TransactionDateFormatRenderer },
  { headerName: 'Car', field: 'car.name', minWidth: 140 },
  { headerName: 'Driver', field: 'driver.name', minWidth: 160 },
  { headerName: 'Confirmed', field: 'confirmed', minWidth: 110, cellRenderer: CheckboxRenderer },
  { headerName: 'Confirmed date', field: 'confirmed_date', minWidth: 150 },
  { headerName: 'Confirmed by', field: 'confirmed_by', minWidth: 140 },
  { headerName: 'Departure begin time', field: 'departure_begin_time', minWidth: 190, cellRenderer: TransactionDateFormatRenderer },
  { headerName: 'Departure end time', field: 'departure_end_time', minWidth: 190, cellRenderer: TransactionDateFormatRenderer },
  { headerName: 'Total hours', field: 'total_hours', minWidth: 120 },
  { headerName: 'Departure begin (Km)', field: 'departure_begin_kilometer', minWidth: 150 },
  { headerName: 'Departure end (Km)', field: 'departure_end_kilometer', minWidth: 150 },
  { headerName: 'Total (Km)', field: 'total_kilometers', minWidth: 120 },
  { headerName: 'Parking fee', field: 'parking_fee', minWidth: 130, valueFormatter: (p) => formatNumber(p.value, 'VND') },
  { headerName: 'Notes', field: 'notes', minWidth: 160 },
  { headerName: 'Closed', field: 'closed', minWidth: 100, cellRenderer: CheckboxRenderer },
  { headerName: 'Created by', field: 'created_by', minWidth: 140 },
  { headerName: 'Created date', field: 'created_at', minWidth: 160 },
];
